import { appointmentGeneralObject } from '@/models/appointmentsGeneral'
import utils from '@/utils/utils'

const _ = require('lodash')

export default {
  /**
   * Actualiza los datos de la nueva cita
   */
  setNewAppointmentData: (state, newAppointment) => {
    state.newAppointment = _.merge(state.newAppointment, newAppointment)
  },
  /**
   * Prepara el objeto de cita desde el servidor.
   * Formatea los campos para ser visualizados en el formulario de edición.
   */
  setUpdateAppointmentFromServer: (state, updateAppointment) => {
    let dt = ''
    if (updateAppointment.appointmentTime) {
      dt = utils.formatDateTime(updateAppointment.appointmentTime)
    } else {
      dt = updateAppointment.appointmentTime
    }

    updateAppointment.nutritionalPlanAdd = updateAppointment.nutritionalPlan
    delete updateAppointment.nutritionalPlan

    state.updateAppointment = _.merge(
      state.updateAppointment,
      updateAppointment,
      { appointmentTime: dt }
    )
  },
  /**
   * Actualiza los datos de la cita a editar
   */
  setUpdateAppointmentGeneralData: (state, updateAppointmentGeneral) => {
    state.updateAppointmentGeneral = _.merge(
      state.updateAppointmentGeneral,
      updateAppointmentGeneral
    )
  },
  /**
   * Actualiza los datos de la cita a editar
   */
  setUpdateScheduledAppointment: (state, updateScheduledAppointment) => {
    state.updateScheduledAppointment = _.merge(
      state.updateScheduledAppointment,
      updateScheduledAppointment
    )
  },
  /**
   * Configura el progreso para la vista de nuevos pacientes.
   */
  setNewAppointmentProgress: (state, { card, status }) => {
    state.newAppointmentProgress[card] = status
  },
  setUpdateAppointmentGeneralProgress: (state, { card, status }) => {
    state.updateAppointmentGeneralProgress[card] = status
  },
  /**
   * Reinicia el objeto de la cita a editar
   */
  clearUpdateGeneralAppointmentData: (state) => {
    state.updateAppointmentGeneral = _.cloneDeep(appointmentGeneralObject)
    state.appointmentGeneralDocs = new FormData()
    state.updateAppointmentGeneralProgress = {
      appointmentFinal: false,
    }
    state.tracingDetailsAdd = []
    state.medicinesAdd = []
    state.laboratoriesAdd = []
    state.segmentalDetailsAdd = []
    state.systemsDetailsAdd = []
  },
  /**
   * Reiniciar el objeto del nuevo paciente general
   */
  clearNewGeneralAppointmentData: (state) => {
    state.newAppointmentGeneral = _.cloneDeep(appointmentGeneralObject)
    state.appointmentGeneralDocs = new FormData()
  },
  /**
   * Configura las citas del paciente que ya se concretaron.
   */
  setAppointmentsGeneralList: (state, appointmentsGeneralList) => {
    state.appointmentsGeneralList = appointmentsGeneralList
  },
  /**
   * Configura el FormData para los documentos de la cita.
   */
  setNewAppointmentGeneralDocs: (state, formData) => {
    state.appointmentGeneralDocs = formData
  },
  /**
   * Configura el FormData para los documentos de la cita.
   */
  setUpdateAppointmentGeneralDocs: (state, formData) => {
    state.appointmentGeneralDocs = formData
  },
  /**
   * Configura el FormData para las fotos de la cita.
   */
  setAppointmentPhotos: (state, formData) => {
    state.appointmentPhotos = formData
  },
  /**
   * Configura las citas del paciente pendientes
   */
  setScheduledAppointmentsList: (state, scheduledAppointmentsList) => {
    state.scheduledAppointmentsList = scheduledAppointmentsList
  },
  setSearchParams: (state, searchParams) => {
    state.searchParams = searchParams
  },
  setSearchParamsCanceledAppointments: (
    state,
    searchParamsCanceledAppointments
  ) => {
    state.searchParamsCanceledAppointments = searchParamsCanceledAppointments
  },
  setSearchParamsScheduledAppointments: (
    state,
    searchParamsScheduledAppointments
  ) => {
    state.searchParamsScheduledAppointments = searchParamsScheduledAppointments
  },
  /**
   * Configura el total de páginas en la lista de citas capturadas
   */
  setTotalAppointmentsPages: (state, pages) => {
    state.totalAppointmentsPages = pages
  },
  /**
   * Configura el total de páginas en la lista de citas agendadas.
   */
  setTotalScheduledAppointmentsPages: (state, pages) => {
    state.totalScheduledAppointmentsPages = pages
  },
}
